import { render, staticRenderFns } from "./coreProductInfo.vue?vue&type=template&id=0d605464&scoped=true"
import script from "./coreProductInfo.vue?vue&type=script&lang=js"
export * from "./coreProductInfo.vue?vue&type=script&lang=js"
import style0 from "./coreProductInfo.vue?vue&type=style&index=0&id=0d605464&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d605464",
  null
  
)

export default component.exports